(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ploumi-bio-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.pboReady) return;
      root.dataset.pboReady = 'true';
      root.querySelectorAll('[data-pbo-select]').forEach(button => {
        button.addEventListener('click', () => {
          const count = button.dataset.pboSelect;
          root.querySelectorAll('[data-pbo-select]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
          root.querySelectorAll('[data-pbo-panel]').forEach(panel => { panel.hidden = panel.dataset.pboPanel !== count; });
          root.querySelectorAll('[data-pbo-image]').forEach(figure => { figure.hidden = figure.dataset.pboImage !== count; });
          root.querySelectorAll('[data-pbo-sticky-price]').forEach(price => { price.hidden = price.dataset.pboStickyPrice !== count; });
        });
      });
      const sticky = root.querySelector('[data-pbo-sticky]');
      const hero = root.querySelector('.pbo-hero');
      const packs = root.querySelector('.pbo-packs');
      if (!sticky || !hero || !packs || !('IntersectionObserver' in window)) return;
      let heroVisible = true;
      let packsVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          if (entry.target === packs) packsVisible = entry.isIntersecting;
        });
        sticky.hidden = heroVisible || packsVisible;
      });
      observer.observe(hero);
      observer.observe(packs);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, { once: true });
    };
    document.querySelectorAll('[data-pbo-section]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pbo-section]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ploumi-reserve-de"]) return;
  try {
    
if(!customElements.get('ploumi-reserve-de')){
class PloumiReserveDE extends HTMLElement{
 connectedCallback(){
  if(this.bound)return;this.bound=true;this.abort=new AbortController();const signal=this.abort.signal;
  this.form=document.getElementById(this.dataset.formId);if(!this.form)return;
  this.idInput=this.form.querySelector('[data-prd-id]');this.buy=this.querySelector('[data-prd-buy]');this.sticky=this.querySelector('[data-prd-sticky]');this.proxy=this.querySelector('[data-prd-proxy]');
  this.options=Array.from(this.querySelectorAll('[data-prd-option]'));this.variants=JSON.parse(this.querySelector('[data-prd-variants]').textContent);this.lastVariant=null;
  const update=(option,writeUrl=false)=>{if(!option)return;option.checked=true;this.idInput.value=option.value;this.querySelectorAll('[data-prd-pack]').forEach(el=>el.textContent=option.dataset.units+' \u00d7 500 ml');this.querySelectorAll('[data-prd-price]').forEach(el=>el.textContent=option.dataset.price);this.querySelectorAll('[data-prd-unit]').forEach(el=>el.textContent=option.dataset.unitPrice);this.buy.disabled=option.disabled;this.proxy.disabled=option.disabled;const variant=this.variants.find(v=>String(v.id)===option.value);this.idInput.dispatchEvent(new Event('change',{bubbles:true}));if(variant)this.form.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant,previousVariant:this.lastVariant}}));this.lastVariant=variant;if(writeUrl){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(history.state,'',url);}this.queueVisibility();};
  this.options.forEach(option=>option.addEventListener('change',()=>{if(option.checked)update(option,true);},{signal}));
  this.proxy.addEventListener('click',()=>{if(!this.buy.disabled&&this.buy.getAttribute('aria-busy')!=='true'){this.buy.click();}},{signal});
  this.addEventListener('click',event=>{const link=event.target.closest('a[href="#prd-packages"]');if(!link)return;const selected=this.options.find(o=>o.checked);if(selected)setTimeout(()=>selected.focus({preventScroll:true}),100);},{signal});
  this.queueVisibility=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.updateVisibility();});};
  window.addEventListener('scroll',this.queueVisibility,{passive:true,signal});window.addEventListener('resize',this.queueVisibility,{passive:true,signal});
  this.observer=new MutationObserver(this.queueVisibility);this.observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','hidden','aria-hidden','aria-busy']});
  const fromUrl=new URL(location.href).searchParams.get('variant');update(this.options.find(o=>o.value===fromUrl)||this.options.find(o=>o.checked));
 }
 updateVisibility(){if(!this.buy||!this.sticky)return;const rect=this.buy.getBoundingClientRect();const buyVisible=rect.top<innerHeight&&rect.bottom>0;const modal=Array.from(document.querySelectorAll('dialog[open],cart-drawer[open],cart-notification-drawer[open],quick-buy-drawer[open],privacy-banner[open],.shopify-pc__banner__dialog,[role="dialog"][aria-modal="true"]')).some(el=>{const box=el.getBoundingClientRect();return box.width>0&&box.height>0&&getComputedStyle(el).visibility!=='hidden'&&el.getAttribute('aria-hidden')!=='true';});const show=innerWidth<900&&!buyVisible&&!modal&&!this.buy.disabled&&this.buy.getAttribute('aria-busy')!=='true';if(this.sticky.hidden===show)this.sticky.hidden=!show;document.body.classList.toggle('prd-sticky-on',show);if(show)document.body.style.setProperty('--prd-sticky-height',this.sticky.offsetHeight+'px');}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);document.body.classList.remove('prd-sticky-on');document.body.style.removeProperty('--prd-sticky-height');this.bound=false;}
}
customElements.define('ploumi-reserve-de',PloumiReserveDE);
}

  } catch(e) { console.error(e); }
})();
})();
